import React from 'react';
import { Helmet } from 'react-helmet';

import useSiteMetadata from '../components/SiteMetadata';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import LocaleContext from '../context/localeContext';
import { ContrastProvider } from '../context/contrastContext';
import TextSizeContext, { TextSizeProvider } from '../context/textSizeContext';
import appleTouchIcon from '../img/apple-touch-icon.png';
import favicon16 from '../img/favicon-16x16.png';
import favicon32 from '../img/favicon-32x32.png';
import safariPinnedTab from '../img/safari-pinned-tab.svg';
import gdiBackground from '../img/gdi-background.jpg';

import '../styles/global.css';

const TemplateWrapper = ({ children }) => {
  const { title, description, baseUrl } = useSiteMetadata();
  const JSONLD = {
    "@context": "https://schema.org",
    "@type": "NGO",
    "name": "Global Disinformation Index",
    "alternateName": "GDI",
    "description": "Disinformation thrives because today’s online business models reward attention over accuracy. The Global Disinformation Index (GDI) was founded to confront this challenge. We began by showing where the risks were. Today, we’ve evolved to focus on fixing the systems that allow disinformation to spread in the first place.",
    "url": "https://disinformationindex.org",
    "keywords": "Global Disinformation Index, GDI, disinformation research",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.disinformationindex.org/img/logo.jpg"
    },
    "sameAs": [
      "https://www.linkedin.com/company/the-global-disinformation-index"
    ],
    "founder": [
      {
        "@type": "Person",
        "name": "Clare Melford",
        "jobTitle": "CEO"
      },
      {
        "@type": "Person",
        "name": "Daniel J. Rogers"
      }
    ]
  };

  return (
    <ContrastProvider>
      <TextSizeProvider>
        <TextSizeContext.Consumer>
          {(textContext) => (
            <div className={`min-h-screen flex flex-col bg-black ${textContext.isLgTextEnabled ? 'embiggen-text' : ''}`}>
              <LocaleContext.Consumer>
                {(context) => (
                  <Helmet>
                    <html lang={context.locale} />
                  </Helmet>
                )}
              </LocaleContext.Consumer>
              <Helmet>
                <title>{title}</title>

                <meta name="description" content={description} />
                <meta name="keywords" content="GDI, Global Disinformation Index, disinformation, misinformation, malinformation, disinformation research, disinformation campaigns"></meta>
                <meta property="og:site_name" content={title} />
                <meta property="og:locale" content="en" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:image" content={`${baseUrl}${gdiBackground}`} />
                <meta property="og:website" content={baseUrl} />
                <meta property="og:url" content={baseUrl} />
                <meta name="theme-color" content="#000" />

                <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
                <link rel="icon" type="image/png" href={favicon32} sizes="32x32" />
                <link rel="icon" type="image/png" href={favicon16} sizes="16x16" />
                <link rel="mask-icon" href={safariPinnedTab} color="#ff4400" />
                <link rel="canonical" href={baseUrl} />

                <script type="application/ld+json">
                  {JSON.stringify(JSONLD)}
                </script>
              </Helmet>
              <Navbar />
              <div className="text-white">{children}</div>
              <Footer />
            </div>
          )}
        </TextSizeContext.Consumer>
      </TextSizeProvider>
    </ContrastProvider>
  );
};

export default TemplateWrapper;
